import AddCircleIcon from "@material-ui/icons/AddCircle"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import PropTypes from "prop-types"
import React from "react"

const NoLessonAdded = ({ onClick }) => {
  return (
    <PermissionsWrapper permissionGroup="admin">
      <DarkButton
        onClick={onClick}
        size="large"
        fullWidth
        startIcon={<AddCircleIcon color="inherit" />}
      >
        Add lesson
      </DarkButton>
    </PermissionsWrapper>
  )
}

NoLessonAdded.propTypes = {
  onClick: PropTypes.func,
}

export default NoLessonAdded
